export default __webpack_public_path__ + "static/media/sportsbra-large-back-toosmall.9eae6abd.jpg";